import { combineEpics } from "redux-observable";
import { epicCheckInstantPackages } from "./epics/epicCheckInstantPackages";
import { epicConsumePackage } from "./epics/epicConsumePackage";
import { epicConsumePackages } from "./epics/epicConsumePackages";
import { epicPackageExpenseConfirmed } from "./epics/epicPackageExpenseConfirmed";
export var epicPackage = combineEpics(epicCheckInstantPackages, epicConsumePackages, epicConsumePackage, epicPackageExpenseConfirmed);



//////////////////
// WEBPACK FOOTER
// ./src/features/item-packages/epicPackage.ts
// module id = 1974
// module chunks = 3